import React,{useEffect} from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import MoneyIcon from "@material-ui/icons/Money";
import { useSelector, useDispatch } from "react-redux";
import { getTotalTurnOver } from "./_dashboard_action";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56,
  },
  differenceIcon: {
    color: colors.red[900],
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1),
  },
}));

const TotalTurnOver = ({ className, ...rest }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.dashboard._totalTurnOver) || [];

  useEffect(() => {
    dispatch(getTotalTurnOver());
  },[])

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              TOTAL TURN OVER
            </Typography>
            <Typography color="textPrimary" variant="h3">
            ₹{allFetchData.totalTurnOver}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              ₹
            </Avatar>
          </Grid>
        </Grid>
        <Box mt={2} display="flex" alignItems="center">
          {/* <ArrowDownwardIcon className={classes.differenceIcon} />
          <Typography className={classes.differenceValue} variant="body2">
            12%
          </Typography>
          <Typography color="textSecondary" variant="caption">
            Since last month
          </Typography> */}
          we have total turn over of ₹{allFetchData.totalTurnOver}
        </Box>
      </CardContent>
    </Card>
  );
};

TotalTurnOver.propTypes = {
  className: PropTypes.string,
};

export default TotalTurnOver;
